import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AUTH_CLIENT_TOKEN, AuthClientProvider, LocalStorageKey } from '@core';
import { inject } from '@angular/core';
import { take, tap } from 'rxjs';

export const sharedGameResolver: ResolveFn<void> = (activatedRoute: ActivatedRouteSnapshot) => {
  const authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  const sharedGameId: string = activatedRoute.params['id'];

  authClientProvider.isAuthed$
    .pipe(
      take(1),
      tap((isAuthed: boolean) => {
        if (isAuthed) return sessionStorage.removeItem(LocalStorageKey.SharedGame);

        return sessionStorage.setItem(LocalStorageKey.SharedGame, sharedGameId);
      })
    )
    .subscribe();
};
